import React, { useState } from 'react';
import { Row, Col, Form, Label, Input, Button } from 'reactstrap';
import DescriptionModal from '../../modals/descriptionModals/DescriptionModal';
import { useFormSection } from 'features/products/context/ProductDetailContext';

const ExtraDetail: React.FC = () => {
  const { watch, setValue, getError } = useFormSection('extraDetails');
  const [isDescModalOpen, setIsDescModalOpen] = useState(false);

  const handleOpenDescModal = () => setIsDescModalOpen(true);
  const handleCloseDescModal = () => setIsDescModalOpen(false);
  const handleSaveDescription = (newDesc: string) => {
    setValue('extraDetail', newDesc);
    setIsDescModalOpen(false);
  };

  return (
    <fieldset className="border rounded p-2">
      <legend className="float-none w-auto px-2 mb-0 text-body" style={{ fontSize: '0.9rem' }}>Extra Detail</legend>
      <Form>
        <Row>
          <Col sm={12}>
            <div className="mb-3">
              <Label htmlFor="extraDetail" className="form-label">
                Extra Details
              </Label>
              <div className="d-flex align-items-start gap-2">
                <Input
                  type="textarea"
                  className="form-control form-control-sm"
                  id="extraDetail"
                  value={watch('extraDetail') || ''}
                  onChange={(e) => {
                    setValue('extraDetail', e.target.value);
                  }}
                  style={{ resize: 'none' }}
                  rows={4}
                  readOnly
                />
                <Button color="light" size="sm" style={{ minWidth: '30px' }} onClick={handleOpenDescModal}>
                  <i className="ri-search-line"></i>
                </Button>
              </div>
              {/* Display validation error if any */}
              {getError('extraDetail') && (
                <div className="text-danger small mt-1">
                  {getError('extraDetail')?.message}
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Form>
      <DescriptionModal
        isOpen={isDescModalOpen}
        onClose={handleCloseDescModal}
        onSave={handleSaveDescription}
        initialValue={watch('extraDetail') || ''}
        title="Extra Details"
      />
    </fieldset>
  );
};

export default ExtraDetail;
